import { I_Settings } from "../components/icons";
import { glassDeep, heading } from "../styles.js";

const ConfigScreen = () => (
    <div className="min-h-screen flex items-center justify-center p-5 text-slate-100">
      <div className={`${glassDeep} max-w-xl rounded-2xl p-8 shadow-2xl`}>
        <div className="w-12 h-12 rounded-xl bg-amber-200/10 text-amber-200 flex items-center justify-center mb-5 ring-1 ring-amber-200/20">
          <I_Settings size={22} />
        </div>
        <h1 className="text-3xl mb-3 text-slate-100" style={heading}>
          Almost there — connect your Supabase
        </h1>
        <p className="text-sm text-slate-300 leading-relaxed mb-4">
          Estatebook needs your free Supabase project to store clients, properties, visits, and
          files. Open this HTML file in a text editor and paste two values near the top of the
          script:
        </p>
        <div className="bg-slate-950 text-slate-200 rounded-lg p-4 text-xs font-mono mb-4 border border-white/[0.08] overflow-x-auto">
          <div>
            const SUPABASE_URL = <span className="text-amber-300">"https://....supabase.co"</span>;
          </div>
          <div>
            const SUPABASE_ANON_KEY = <span className="text-amber-300">"eyJhbGci..."</span>;
          </div>
        </div>
        <p className="text-sm text-slate-400">
          Find both in Supabase → <strong className="text-slate-200">Project Settings → API</strong>
          . The setup guide that came with this app walks through every step.
        </p>
      </div>
    </div>
  );

export { ConfigScreen };
